import client from './client';
import { IRegionResponse } from '@/types/api-responses';

export async function getRegions() {
    const { data } = await client.GET('/api/v1/public/regions');
    return data as unknown as IRegionResponse[];
}